import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useAuth } from '../hooks/useAuth'
import { getItem } from '../utils/handleLocalStorage'
import { Loader } from '../../users/components/Loader'
import styles from '../styles/login.module.scss'

export default function OAuthCallback() {
  const location = useLocation()
  const auth = useAuth()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    // Verificar si el código es válido y no ha sido procesado previamente
    if (code && !getItem('token') && getItem('oauthCodeProcessed') !== code) {
      auth.handleOAuthCallback(code);
    }

  }, [location, auth]);

  return (
    <div className={styles["authPage"]}>
      <h1>Autenticando...</h1>
      <Loader />
    </div>
  )
}
